import React from "react";
import styles from "../styles/notificaciones.module.css";
import { fmtDate } from "../domain/dateUtils";
import { useTitularesData } from "../hooks/useTitularesData";
import { useAlertasTitularesViewModel } from "../hooks/useAlertasTitularesViewModel";

export default function AlertasTitulares() {
    const { loading, personas, error } = useTitularesData();
    const vm = useAlertasTitularesViewModel(personas);

    if (loading) {
        return (
            <div className="notif-view">
                <div className="loading">Cargando alertas de titulares…</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="notif-view">
                <div className="error">
                    <strong>Ha ocurrido un error:</strong> {error}
                </div>
            </div>
        );
    }

    return (
        <div className={styles["notif-view"]}>
            <div className={styles.titlebar}>
                <div>
                    <h2 className={styles.title}>Alertas de Titulares</h2>
                    <p className={styles.subtitle}>
                        Licencias de armas de Titulares que caducan en los próximos 3 meses
                    </p>
                </div>
            </div>

            <div className={styles["controls-grid"]}>
                <div className={styles["controls-card"]}>
                    <div className={styles["controls-title"]}>Filtros</div>
                    <div className={styles["controls-row"]}>
                        <input
                            className={styles.input}
                            placeholder="Buscar (titular, Nº licencia…)"
                            value={vm.query}
                            onChange={(e) => vm.setQuery(e.target.value)}
                        />
                        <select className={styles.input} value={vm.estado} onChange={(e) => vm.setEstado(e.target.value)}>
                            <option value="all">Todas</option>
                            <option value="expired">Vencidas</option>
                            <option value="soon">Próximas</option>
                            <option value="missing">Sin fecha</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className={styles.kpis}>
                <div className={styles.kpi}>
                    <span className={styles["kpi-title"]}>Total</span>
                    <span className={styles["kpi-value"]}>{vm.kpi.total}</span>
                </div>
                <div className={styles.kpi}>
                    <span className={styles["kpi-title"]}>Vencidas</span>
                    <span className={styles["kpi-value"]}>{vm.kpi.cad}</span>
                </div>
                <div className={styles.kpi}>
                    <span className={styles["kpi-title"]}>Próximas</span>
                    <span className={styles["kpi-value"]}>{vm.kpi.soon}</span>
                </div>
            </div>

            {vm.filtered.length === 0 ? (
                <div className={styles.empty}>
                    <div className={styles.emoji}>🔫</div>
                    <h3>Sin alertas</h3>
                    <p>Ningún titular tiene la licencia de armas vencida o a punto de caducar.</p>
                </div>
            ) : (
                <div className={styles["table-wrap"]}>
                    <table className={`${styles.table} ${styles.responsive}`}>
                        <thead>
                            <tr>
                                <th>Titular</th>
                                <th>Detalle</th>
                                <th>Fecha</th>
                                <th>Días</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vm.filtered.map((a) => (
                                <tr key={a.id}>
                                    <td data-label="Titular">{a.personName}</td>
                                    <td data-label="Detalle" className={styles.muted}>{a.meta || "—"}</td>
                                    <td data-label="Fecha">{fmtDate(a.fecha)}</td>
                                    <td data-label="Días">{a.daysLeft ?? "—"}</td>
                                    <td data-label="Estado">
                                        <span className={`${styles.pill} ${a.status === "expired" ? styles.danger : styles.warn}`}>
                                            {a.status === "expired" ? "Vencida" : a.status === "soon" ? "Próxima" : "Sin fecha"}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
